import { render, staticRenderFns } from "./send-type-content.vue?vue&type=template&id=0dc83287&scoped=true&"
import script from "./send-type-content.vue?vue&type=script&lang=js&"
export * from "./send-type-content.vue?vue&type=script&lang=js&"
import style0 from "./send-type-content.vue?vue&type=style&index=0&id=0dc83287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc83287",
  null
  
)

export default component.exports